import React from 'react'
import cx from 'classnames'
import Spinner from 'components/Spinner'
import styles from './CompletionToggle.sass'
import Icon from 'components/Icon'
import { isChildrenEmpty } from '../../utils/react-util'

interface CompletionToggleProps {
  completed?: boolean
  onClick?: () => unknown
  children?: React.ReactNode
  title?: string
  processing?: boolean
  readOnly?: boolean
  pulse?: boolean
  disabled?: boolean
  size?: number
  dataTest?: string
  checkType?: CheckType
}

export default function CompletionToggle({
  completed,
  onClick,
  children,
  title,
  processing,
  readOnly,
  pulse,
  disabled,
  size = 24,
  dataTest,
  checkType = 'checkmark',
}: CompletionToggleProps) {
  const click = () => !processing && onClick?.()
  const styleProps = { width: size, height: size }
  const hasChildren = !isChildrenEmpty(children)
  return (
    <button
      className={cx(styles.root, !readOnly && styles.toggleable)}
      onClick={click}
      title={title}
      style={styleProps}
      tabIndex={readOnly ? -1 : undefined}
      data-test={dataTest}
    >
      {processing ? (
        <Spinner thickness={2} />
      ) : (
        <React.Fragment>
          <div
            className={cx(styles.back, pulse && styles.pulse)}
            style={styleProps}
          />
          {completed && (
            <div className={styles.front} style={styleProps}>
              <div className={styles.content}>{children}</div>
              <span style={styleProps}>
                <Icon
                  name={checkType}
                  size={size}
                  className={cx(
                    styles[checkType],
                    !hasChildren && styles.enlarged,
                    disabled && styles.disabled,
                  )}
                />
              </span>
            </div>
          )}
        </React.Fragment>
      )}
    </button>
  )
}

export type CheckType = 'tick' | 'checkmark'
